<template>
  <div class="intro">
    <img src="/apple-icon.png" alt="" class="logo">
    <div>
      {{ introText }}
      <div class="footer">
        <img src="/ccc-parchment.png" alt="community created content" />
        {{ t('intro.footer') }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  useLocaleStore,
} from '@/stores';
import { computed } from 'vue';
const locale = useLocaleStore();
const t = locale.t;
const owner = import.meta.env["VITE_OWNER"];
const introText = computed(() => t('intro.body').replace('$owner', owner) );
</script>

<style scoped lang="scss">
// Intro
.intro {
  text-align: center;
  width: 50%;
  font-size: clamp(16px, calc(-1.1429rem + 4.2857vw), 28px);
  position: absolute;
  padding: 10px;
  background: var(--background-color);
  backdrop-filter: blur(3px);
  border: 3px solid var(--border-color);
  border-radius: 10px;
  z-index: 3;
  display: flex;
  justify-content: center;

  a {
    color: white;
  }

  a.redirect {
    display: block;
    text-decoration: none;
    position: absolute;
    top: 100%;
    margin-top: 2vh;
    padding: 10px;
    background: var(--background-color);
    backdrop-filter: blur(3px);
    border: 3px solid var(--border-color);
    border-radius: 10px;

    &:hover {
      color: red;
      text-shadow: 0 0 2px black;
    }

    img {
      width: 120px;
      display: block;
      margin: auto;
      margin-bottom: 1vh;
    }
  }

  img.logo {
    position: absolute;
    bottom: 100%;
    width: 25vh;
    margin-bottom: 2vh;
    max-width: 192px;
    border-radius: 50%;
    box-shadow: 0 0 10px black;
    border: 3px solid var(--border-color);
  }

  .footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 60%;
    opacity: 0.75;

    img {
      height: 3em;
    }
  }
}
</style>
